import React, {useState,useRef, useEffect } from 'react';
import CustomButtoncolor from "../custom-button/customColorButton";
import {Avatar, Box, Button, Checkbox, Drawer, FormControlLabel, Grid, Hidden, IconButton, Stack, Tab, Tabs, Typography} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import CustomModal from "../modal/customModal";
import moment from "moment/moment";
import {
    getCrmAppointmentHolidays,
    getCrmAppointmentSchedule,
    rescheduleAppointment
} from "../../store/crm/appointment/book-appointment";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../loader/loader";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AppointmentTime from "../../pages/crm/appointment/add-appointment/appointmentTime";
import {MySwal, successConfirmation} from "../../services/utills";
import {mySwalButton, mySwalButtonCancel, mySwalButtonYes} from "./CardAppointment";
import CustomButton from "../custom-button/customButton";
import {getAllAppointment, getAllRequestedAppointment, getAppointmentDetails, getAppointmentHistory, getAppointmentcalender} from "../../store/crm/appointment";
import Waveloading from '../../pages/loading/Waveloading';
import { Navigate, useNavigate } from 'react-router';
import { getCRMCustomerBookingsDetails } from '../../store/crm/crm';
import { appointmentCallLogData } from '../../store/crm/call-log';
import ScheduleIcon from "@mui/icons-material/Schedule";
import CRMPage from '../../pages/crm/crmpage/CRMPage';
import { getStaff } from '../../store/crm/staffs';
import { getProviderStaff } from '../../store/crm/staff';
import toast from 'react-hot-toast';
import AddNotesModal from '../modal/AddNotesModal';

const AppointmentReschedule = ({ requestappointment,  endDate, startDate, isbtn, triggerReload,appointment,isConfirm, iscall, isBooking, isAppointment,isRequested,isMouseEnter,setIsMouseEnter,fetchAppointment, fwidth,onRescheduleSuccess,endTime, isCalender}) => {
// console.log("start and end date", appointment)

    const [rescheduleModal, setRescheduleModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedFinalDate,setSelectedFinalDate] = useState(null)
    const [selectedTime,setSelectedTime] = useState(null) 
    const navigate = useNavigate()
      const [selectedStaff, setSelectedStaff] = useState(null)
 
    const [apiValue, setApiValue] = useState(1);  
    const crmStaffStore = useSelector(state => state?.crmStaffStore)
    const {crmStaffs = []} = crmStaffStore
    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setApiValue(checked ? 1 : 0);
      };

 

      //console.log("resecdule data coming",appointment)
 
    const dispatch = useDispatch()  

    useEffect(() => {
        if (appointment?.staff?.id && crmStaffs?.length > 0) {
          const matched = crmStaffs.find((staff) => staff.id === appointment.staff.id);
          if (matched) {
            setSelectedStaff(matched);
          }
        }
      }, [appointment, crmStaffs]);
      
      const handleStaffSelection = (staff) => {
        if (selectedStaff?.id === staff.id) {
          setSelectedStaff(null);
          //console.log("staff",selectedStaff?.id)
        } else {
          setSelectedStaff(staff);
          //console.log("staff",selectedStaff?.id)
        //   scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
      };
    const getAppointmentHoliday = async (date, staff) => {
        setLoading(true) 
        let finalDate = moment(date).format('YYYY-MM-DD')
        // setSelectedFinalDate(finalDate)
        if (finalDate) {
            let finalData = {
                date: finalDate
            }
          /*  if (staff?.id) {
                finalData['staff_id'] = staff?.id
            }*/
            await dispatch(getCrmAppointmentHolidays(finalData))
        }

        setLoading(false)      

    }
    const getAppointmentSchedule = async (date) => {

        setLoading(true)
        let serviceIds = []
        appointment?.services.forEach((item) => {
            serviceIds.push(item?.id)
        })


        let finalDate = moment(date).format('YYYY-MM-DD')

        setSelectedFinalDate(finalDate)
        setSelectedTime(null)
        let finalData = {
            date: finalDate,
            service_ids: serviceIds
        }

        await dispatch(getCrmAppointmentSchedule(finalData))
  
        setLoading(false)           
       
    }    
 
    const handleReschedule = async () => {
        // let confirm = await MySwal.fire({ 
        //     // icon: 'question',   
        //     title: 'Reschedule?',
           

        //     showConfirmButton: false,
        //     customClass: {
        //         icon: 'custom-icon-size',
        //         popup: 'custom-popup-shadow',
        //         closeButton: 'custom-close-button',
        //       },
        //     showCloseButton: true,
        //     html:    <Stack
        //           sx={{ width: '100%', justifyContent: "center", alignItems: "center" }}
        //           direction={{ xs: 'column', lg: 'row',sm:"row" }}
        //           spacing={2}
        //         >
        //           <Button sx={mySwalButtonYes} onClick={() => MySwal.clickConfirm()}>Yes</Button>
        //           <Button sx={mySwalButtonCancel} onClick={() => MySwal.close()}>No</Button>
        //         </Stack> 
        // })
        // if (!!confirm?.isConfirmed) {

            if (appointment?.date && appointment?.end_time && appointment?.start_time) {
                let givenDate = moment(appointment?.date);
                let today = moment(new Date());

                    setLoading(true)
                   
                    await getAppointmentHoliday(appointment?.date, appointment?.staff)
                    await getAppointmentSchedule(appointment?.date)
                    dispatch(getProviderStaff())
                    setSelectedFinalDate(appointment?.date)
                     
                    setLoading(false)
                    setRescheduleModal(true)
             
            }else {
                setRescheduleModal(true)
            }
        // }
    }
    const handelRescheduleClick = async () => {
        setRescheduleModal(false)
        setLoading(true)
        let finalData = {
            staff_id: selectedStaff?.id || null,
            booking_id:appointment?.id,
            date:selectedFinalDate,
            start_time:selectedTime?.start_time,
            end_time:selectedTime?.end_time,
            is_email_send:apiValue,
        }
        let {payload} = await dispatch(rescheduleAppointment(finalData))

        if (payload?.success === "true"){
          // Independent refreshes run together instead of one after another.
          const refreshes = []
          if(isRequested){
              refreshes.push(dispatch(getAllRequestedAppointment()))
          }
          if (requestappointment){
              refreshes.push(dispatch(getAllRequestedAppointment({start_date: startDate, end_date: endDate})))
          }
          if (isCalender){
              refreshes.push(dispatch(getAppointmentcalender(appointment?.id)))
          }
          if(isAppointment){
              refreshes.push(dispatch(getAppointmentDetails(appointment?.id)))
              refreshes.push(dispatch(getAllAppointment({start_date:"null",end_date:"null"})))
          }
          //call when reschudle from booking history
          if(isBooking){
              refreshes.push(dispatch(getAppointmentHistory({
                  user_id:appointment?.customer?.id,type:'Appointments'
              })))
              refreshes.push(dispatch(getCRMCustomerBookingsDetails({
                  id:appointment?.customer?.id,
                  type:'Appointments'
              })))
          }
          if(iscall){
              refreshes.push(dispatch(appointmentCallLogData()))
          }
          await Promise.allSettled(refreshes)
            // await dispatch(getAppointmentDetails(appointment?.id))
            // await dispatch (getAppointmentHistory({
            //     user_id:appointment?.customer?.id,type:'Appointments'
            // }))
            // await dispatch (getCRMCustomerBookingsDetails({
            //     id:appointment?.customer?.id,
            //     type:'Appointments'
            // }))

            // await dispatch(getAllAppointment({start_date:"null",end_date:"null"}))
            // await dispatch(appointmentCallLogData());

           
         
            setLoading(false)  

            await toast.success("Appointment rescheduled successfully!")
             if(triggerReload){
                triggerReload()
             }

            setRescheduleModal(false)
            if (onRescheduleSuccess) {
                onRescheduleSuccess();
              }
        }else {
            setLoading(false)
        }
    }
    const handleTimeSelect = (slotsArray, startTime) => {
        // Implement your logic for handling time slot selection here
        
        // Scroll to the Reschedule Appointment button
        // if (rescheduleButtonRef.current) {
        //   rescheduleButtonRef.current.scrollIntoView({ behavior: 'smooth' });
        // }
      };
       
      const rescheduleButtonRef = useRef(null);

      // Function to execute scrolling to the reschedule button
      const executeScroll = () => {
        setTimeout(() => {
            rescheduleButtonRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      };


      
          

    const PRIMARY = "#A72C68";
    const PRIMARY_LIGHT = "#FAEFF5";
    const PRIMARY_BORDER = "#F0CDDB";
    const PRIMARY_GRADIENT = "linear-gradient(135deg,#A72C68 0%,#921F58 100%)";

    return (
        <Box>

            {/* Loader while the initial reschedule data (holidays/schedule/staff)
                is fetched — the drawer isn't open yet, so the drawer-scoped cover
                loader below can't render. Show a full-screen loader in that gap. */}
            {loading && !rescheduleModal && <Waveloading fullSize />}

            { appointment?.id && <Drawer
                anchor="right"
                open={rescheduleModal}
                onClose={() => setRescheduleModal(false)}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: 560, md: 700, lg: 820 },
                        maxWidth: '100vw',
                        background: '#fff',
                        boxShadow: '-12px 0 40px rgba(0,0,0,0.10)',
                    },
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    {/* Header */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            px: { xs: 2, sm: 2.5 },
                            py: 2,
                            borderBottom: `1px solid ${PRIMARY_BORDER}`,
                            flexShrink: 0,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '10px',
                                    background: PRIMARY_LIGHT,
                                    border: `1px solid ${PRIMARY_BORDER}`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <CalendarMonthOutlinedIcon sx={{ color: PRIMARY, fontSize: 22 }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: '17px', fontWeight: 700, color: '#1a1a2e', lineHeight: 1.2 }}>
                                    Reschedule Appointment
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: 0.25 }}>
                                    Choose a new date and time for this appointment.
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton
                            size="small"
                            onClick={() => setRescheduleModal(false)}
                            sx={{
                                color: '#6B7280',
                                borderRadius: '8px',
                                width: 32,
                                height: 32,
                                '&:hover': { background: PRIMARY_LIGHT, color: PRIMARY },
                            }}
                        >
                            <CloseIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                    </Box>

                    {/* Body */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: 'auto',
                            position: 'relative',
                            px: { xs: 2, sm: 2.5 },
                            py: 2,
                            '&::-webkit-scrollbar': { width: '4px' },
                            '&::-webkit-scrollbar-thumb': { background: PRIMARY_BORDER, borderRadius: '4px' },
                        }}
                    >
                        {loading && <Waveloading cover />}
                        {appointment?.date && (
                            <Box
                                sx={{
                                    background: PRIMARY_LIGHT,
                                    border: `1px solid ${PRIMARY_BORDER}`,
                                    borderRadius: '12px',
                                    p: 2,
                                    mb: 2.5,
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
                                    <EventOutlinedIcon sx={{ fontSize: 16, color: PRIMARY }} />
                                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: PRIMARY, letterSpacing: '0.6px' }}>
                                        CURRENT APPOINTMENT
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                    <CalendarMonthOutlinedIcon sx={{ fontSize: 16, color: '#1a1a2e' }} />
                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#1a1a2e' }}>
                                        {moment(appointment?.date).format('dddd, Do MMMM, YYYY')}
                                        {appointment?.start_time ? ` at ${appointment?.start_time}` : ''}
                                    </Typography>
                                </Box>
                            </Box>
                        )}

                        <Box sx={{ width: '100%', mb: 2.5 }}>
                            {crmStaffs?.length > 0 ? (
                                <Tabs
                                    value={selectedStaff?.id || false}
                                    variant="scrollable"
                                    scrollButtons
                                    allowScrollButtonsMobile
                                    onChange={(e, newValue) => {
                                        const selected = crmStaffs.find((staff) => staff.id === newValue);
                                        handleStaffSelection(selected);
                                    }}
                                    sx={{
                                        borderBottom: `1px solid ${PRIMARY_BORDER}`,
                                        mb: 1,
                                        '& .MuiTabs-indicator': { background: PRIMARY_GRADIENT, height: 3, borderRadius: '3px' },
                                        '& .MuiTabScrollButton-root': {
                                            color: PRIMARY,
                                            background: PRIMARY_LIGHT,
                                            borderRadius: '8px',
                                            border: `1px solid ${PRIMARY_BORDER}`,
                                            width: 28,
                                            height: 28,
                                            mx: 0.5,
                                            '&.Mui-disabled': { opacity: 0.4 },
                                        },
                                    }}
                                >
                                    {crmStaffs.map((staff) => {
                                        const active = selectedStaff?.id === staff.id;
                                        return (
                                            <Tab
                                                key={staff.id}
                                                value={staff.id}
                                                disableRipple
                                                label={
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                                        <Box
                                                            sx={{
                                                                position: 'relative',
                                                                p: 0.5,
                                                                borderRadius: '12px',
                                                                background: active ? PRIMARY_LIGHT : 'transparent',
                                                                border: active ? `1.5px solid ${PRIMARY}` : '1.5px solid transparent',
                                                                transition: 'all 0.15s ease',
                                                            }}
                                                        >
                                                            <Avatar
                                                                src={staff.profile_image}
                                                                variant="rounded"
                                                                sx={{ width: 70, height: 70, borderRadius: '10px' }}
                                                            />
                                                        </Box>
                                                        <Typography
                                                            sx={{
                                                                fontSize: '12px',
                                                                fontWeight: active ? 700 : 500,
                                                                color: active ? PRIMARY : '#1a1a2e',
                                                                maxWidth: 92,
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                textTransform: 'capitalize',
                                                            }}
                                                        >
                                                            {staff.name}
                                                        </Typography>
                                                    </Box>
                                                }
                                                sx={{
                                                    minWidth: 100,
                                                    textTransform: 'none',
                                                    p: 1,
                                                }}
                                            />
                                        );
                                    })}
                                </Tabs>
                            ) : (
                                <Typography sx={{ color: '#9CA3AF', textAlign: 'center', py: 2 }}>No Staff Found</Typography>
                            )}
                        </Box>

                        <AppointmentTime
                            panelMode
                            selectedFinalDate={selectedFinalDate}
                            setSelectedFinalDate={setSelectedFinalDate}
                            selectedTime={selectedTime}
                            selectedStaff={appointment?.staff || null}
                            setSelectedTime={setSelectedTime}
                            selectedServices={appointment?.services}
                            getAppointmentHoliday={getAppointmentHoliday}
                            getAppointmentSchedule={getAppointmentSchedule}
                            handleTimeSelect={handleTimeSelect}
                            executeScroll={executeScroll}
                        />
                        <Box ref={rescheduleButtonRef} />
                    </Box>

                    {/* Footer */}
                    <Box
                        sx={{
                            px: { xs: 2, sm: 2.5 },
                            py: 1.75,
                            borderTop: `1px solid ${PRIMARY_BORDER}`,
                            background: '#FDFBFC',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 1.25,
                            flexWrap: 'wrap',
                            flexShrink: 0,
                        }}
                    >
                        <FormControlLabel
                            size="small"
                            control={
                                <Checkbox
                                    checked={apiValue === 1}
                                    onChange={handleCheckboxChange}
                                    sx={{
                                        color: '#D08CAA',
                                        '&.Mui-checked': { color: PRIMARY },
                                        '& .MuiSvgIcon-root': { fontSize: 20 },
                                    }}
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e', fontWeight: 500 }}>
                                    Send Notification
                                </Typography>
                            }
                            sx={{ m: 0 }}
                        />
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
                            <AddNotesModal appointmentDetails={appointment} appointment wid={"100%"} />
                            <Button
                                onClick={handelRescheduleClick}
                                disabled={!selectedTime?.start_time}
                                startIcon={<CalendarMonthOutlinedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    borderRadius: '10px',
                                    background: 'linear-gradient(135deg, #27AE60 0%, #1E8449 100%)',
                                    color: '#fff',
                                    border: '1px solid #27AE60',
                                    px: 2.5,
                                    py: 1.1,
                                    boxShadow: 'none',
                                    '&:hover': {
                                        background: '#219653',
                                        color: '#fff',
                                        border: '1px solid #27AE60',
                                        boxShadow: 'none',
                                    },
                                    '&.Mui-disabled': {
                                        background: '#E5E7EB',
                                        color: '#9CA3AF',
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                Confirm Reschedule
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Drawer>}

           {requestappointment ? (
    <Button
    fullWidth
    variant="outlined"
    startIcon={<ScheduleIcon />}
    onClick={() => handleReschedule(appointment?.id)}
    sx={{
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: "999px",
        color: "#ff5907",
        borderColor: "#ff5907",
        borderWidth: '1.5px',
        background: '#fff',
        px: 3,
        py: 0.85,
        transition: "all 0.2s ease",
        '& .MuiSvgIcon-root': { color: "#ff5907" },
        '&:hover': {
            backgroundColor: "#ff5907",
            color: "#FFFFFF",
            borderColor: "#ff5907",
            borderWidth: '1.5px',
            '& .MuiSvgIcon-root': { color: "#FFFFFF" },
        }
    }}
>
    Reschedule
</Button>

) : isRequested ? (
    <Button
        variant="outlined"
        color="info"
        onMouseEnter={() => {
            setIsMouseEnter(true)
        }}
        onMouseLeave={() => {
            setIsMouseEnter(false)
        }}
        onClick={() => isMouseEnter && appointment?.id && handleReschedule()}
        sx={{
            height: '100%'
        }}
    >
        Reschedule
    </Button>
) : isConfirm ? (
    <Box sx={{ mt: 4 }}>
        <Typography
            variant="h6"
            color="initial"
            sx={{
                color: '#1565c0',
                marginTop: '5px',
                fontFamily: "helvetica-lt-std-bold",
                cursor: 'pointer',
            }}
            onClick={() => appointment?.id && handleReschedule()}
        >
            Reschedule appointment
        </Typography>
    </Box>
) : (
    <CustomButtoncolor
        mainColor={"#ff5907"}
        handleClick={() => appointment?.id && handleReschedule()}
        style={{ borderRadius: "4px", padding: '10px 15px', width: fwidth }}
        val={"Reschedule"}
        icon={isbtn ? <CancelIcon /> : <ScheduleIcon />}
    />
)}




        </Box>
    );
};

export default AppointmentReschedule;